<template>
  <el-dialog v-if="dialogVisible" :title="$t('billingPage.ChoseProfileTemplate')" :visible.sync="dialogVisible" width="750px" :before-close="handleCancel">
    <el-form :model="form" :inline="true">
      <el-form-item :label="$t('billingPage.searchName')">
        <BjInput v-model="form.keywords" :placeholder="$t('inputText')" clearable />
      </el-form-item>
      <el-button type="primary" style="margin-left:10px" @click="_getProfileCategories">{{ $t('searchText') }}</el-button>
      <el-table ref="refsTable" :data="tableList" style="width: 100%" border @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column type="index" :label="$t('billingPage.index')" align="center" width="60"></el-table-column>
        <el-table-column prop="name" :label="$t('billingPage.profileTemplateName')" align="center">
          <!-- <template slot-scope="scope">
             <el-link type="primary" @click="$router.push('/business/billing/ProfileTemplates/index')">{{ scope.row.name }}</el-link>
          </template> -->
        </el-table-column>
        <el-table-column prop="gmtCreate" :label="$t('billingPage.lastUpdatedAt')" align="center"></el-table-column>
        <el-table-column prop="gmtUpdate" :label="$t('billingPage.lastUpdatedBY')" align="center"></el-table-column>
        <el-table-column :label="$t('billingPage.usersCount')" align="center" width="120">
          <template slot-scope="scope">
             <el-link type="primary" @click="openClient(scope.row)">{{ scope.row.clientCodes.length }}</el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="handleSend">{{ $t('okText') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { billApi } from '@/api';

export default {
  data() {
    return {
      dialogVisible: false,
      form: {},
      rules: {},
      tableList: [],
      dataList: [],
      selectRow: {}
    };
  },
  mounted() {
    this._getProfileCategories();
  },
  methods: {
    openClient(item) {
      if (item.clientCodes.length == 0) return;
      this.$alert(item.clientCodes.join(','), {
        confirmButtonText: this.$t('toast.okText'),
      });
    },
    handleSelectionChange(row) {
      if (row.length > 1) {
        row.shift();
        this.$refs.refsTable.clearSelection();
        this.$refs.refsTable.toggleRowSelection(row[0]);
      } else if (row.length == 1) {
        const arr = this.dataList.filter(item => item.profileTemplate.id == row[0].id);
        this.selectRow = {
          billProfileTemplateId: row[0].id,
          categoryCodes: arr[0].categoryCodes,
          profileTemplate: arr[0].profileTemplate
        };
      }
    },
    _getProfileCategories() {
      billApi.getProfileCategories({keywords: this.form.keywords}).then(res => {
        const tableList = [];
        res.data.content && res.data.content.forEach(item => {
          tableList.push({
            ...item.profileTemplate,
            clientCodes: item.clientCodes || []
          });
        });
        this.tableList = tableList;
        this.dataList = res.data.content;
      });
    },
    handleCancel() {
      this.form.keywords = '';
      this.dialogVisible = false;
      this._getProfileCategories();
    },
    handleSend() {
      this.handleCancel();
      this.selectRow.categoryCodes.forEach(item => {
        item.billCategories.forEach((jitem) => {
          this.$set(jitem, 'price', jitem.standardPrice);
        });
      });
      this.$emit('submit', this.selectRow);
    },
    toggleSelection(val) {
      this.tableList.forEach((item) => {
        if (item.id == val) {
          this.$refs.refsTable.toggleRowSelection(item);
        }
      });
    },
  },
};
</script>
